<script setup>
import AppLayout from '@/Layouts/AppLayout.vue'
import { Inertia } from '@inertiajs/inertia'
import DialogModal from '@/Components/DialogModal.vue'
import PrimaryButton from '@/Components/PrimaryButton.vue'
import { ref } from 'vue'

const showRestartModal = ref(false)

const confirmRestart = () => {
  showRestartModal.value = true
}

const closeRestartModal = () => {
  showRestartModal.value = false
}

const performRestart = () => {
  Inertia.post(route('admin.restart-invoice'), {}, {
    preserveScroll: true,
    onSuccess: () => closeRestartModal()
  })
}

</script>

<template>
  <AppLayout title="Administration">
    <div class="mx-auto py-10 px-6">
      <h2 class="font-semibold text-xl text-gray-800 leading-tight mb-4">Administration</h2>
      
      <h3 class="text-l font-semibold mb-4">Hyperlinks</h3>
      <div class="text-left space-x-2 mb-6">
        <a :href="route('admin.vendors.active')" class="underline">Vendors</a>  | 
        <!--<a href="/content/admin/Timeclock/index.php" class="underline">Time Clock</a>  |-->
        <a :href="route('admin.knowledgebase.index')" class="underline">Knowledgebase</a> | 
        <a :href="route('admin.companies.active')" class="underline">Companies</a>  | 
        <a :href="route('internal.office-calendar.index')" class="underline">Calendar</a>  | 
        <a :href="route('admin.tax.index')" class="underline">Tax</a> | 
        <a :href="route('admin.measurements.index')" class="underline">Measurements</a> | 
        <a v-if="$page.props.auth.user.employeeID === 34 || $page.props.auth.user.employeeID === 2"
           :href="route('admin.audit-log.index')" class="underline">Tracking Log</a>  | 
        <a :href="route('admin.carrier.index')" class="underline">Carrier</a>  | 
        <a :href="route('inventory.index')" class="underline">Inventory</a>  | 
        <!--<a href="/content/admin/sample_database/conveyor_edit01.php" class="underline">Add / Edit a Conveyor</a>-->
      </div>

      <h3 class="text-l font-semibold mb-4">Projects</h3>
      <div class="space-x-2 mb-6">
        <a :href="route('admin.projects.index')" class="underline">Main Projects Page</a> | 
        <a :href="route('admin.projects.create')" class="underline">Add New Project</a> |
        <a :href="route('admin.reports.project-report.index')" class="underline">Project Report</a>
      </div>

      <h3 class="text-l font-semibold mb-4">Invoices</h3>
      <div class="space-x-2 mb-6">
        <a href="#" @click.prevent="confirmRestart" class="underline">Restart Invoice</a>
      </div>

      <!--<h3 class="text-l font-semibold mb-4">Packages</h3>
      <div class="space-x-2 mb-6">
        <a href="/content/admin/image_file/image_file_list.php" class="underline">Picture/File Package</a>  |
        <a href="/content/admin/element/element_list.php" class="underline">Element Package</a>
      </div>-->

      <h3 class="text-l font-semibold mb-4">Workorders</h3>
      <div class="space-x-2 mb-6">
        <a :href="route('admin.workorders.create')" class="underline">New Workorder</a>  |
        <a :href="route('admin.workorders.index')" class="underline">View Workorders</a>
      </div>

      <h3 class="text-l font-semibold mb-4">Global Pricing</h3>
      <div class="space-x-2 mb-6">
        <a :href="route('admin.pricing.index')" class="underline">Type and Global Pricing</a>
      </div>

      <h3 class="text-l font-semibold mb-4">Database</h3>
      <div class="space-x-2 mb-6">
        <a :href="route('admin.database.index')" class="underline">See Database</a>
      </div>
    </div>
  </AppLayout>

  <DialogModal :show="showRestartModal" @close="closeRestartModal">
  <template #title>
    Confirm Restart
  </template>

  <template #content>
    Are you sure you want to restart the invoice sequence? This action cannot be undone.
  </template>

  <template #footer>
    <PrimaryButton class="mr-4" @click="closeRestartModal">Cancel</PrimaryButton>
    <PrimaryButton class="bg-red-600 hover:bg-red-700 text-white" @click="performRestart">Restart</PrimaryButton>
  </template>
</DialogModal>

</template>

